import React, { useState, useEffect } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import LZString  from 'lz-string';
import VentilationCharts from './VentilationCharts';
import HeatingCharts from './HeatingCharts';
import Settings from './Settings';
import HeatingSettings from './HeatingSettings';
import VentilationSettings from './VentilationSettings';
import ConsumptionSettings from './ConsumptionSettings';
import { useUser } from './UserContext';
import MonthlyStatus from './MonthlyStatus';
import MonthlyDataManager from './MonthlyDataManager';
import MonthlyStatusAdapter from './MonthlyStatusAdapter';





function Main() {
  const { userData, jwtToken, loadingUser } = useUser();
  const [currentDate, setCurrentDate] = useState(new Date());
  // Add currentMonth state for monthly data
  //const [currentMonth, setCurrentMonth] = useState(formatYearMonth(new Date()));
  const [tabIndex, setTabIndex] = useState(0);
  const [saveStatus, setSaveStatus] = useState('');
  
  const [appData, setAppData] = useState({
    ventilation: null,
    heating: null,
    configs: {
      ventilation: null,
      heating: null,
      consumption: null
    },
    monthly: null
  });

  const [errors, setErrors] = useState({
    ventilation: null,
    heating: null,
    ventilationState: null,
    heatingState: null,
    monthly: null
  });

  const [loading, setLoading] = useState({
    main: true,
    monthly: true
  });

 // Use MonthlyDataManager hook to get all the necessary functionality
  // Use MonthlyDataManager as a hook
   const {
    currentMonth,
    onPreviousMonth,
    onNextMonth,
    fetchMonthlyData,
    dataCache,
    isActualCurrentMonth,
    hasMoreHistory
  } = MonthlyDataManager({
    userData,
    jwtToken,
    setAppData,
    setErrors,
    setLoading
  });

  useEffect(() => {
    if (!userData) return;
    console.log("useEffect to fetchData", currentDate);
    fetchData(currentDate);
  }, [userData, currentDate]);
  
  useEffect(() => {
    if (!userData) return;
    
    console.log("fetchMonthlyData", currentMonth);
    fetchMonthlyData();
  }, [userData, currentMonth]);
  
  
useEffect(() => {
  console.log("Main component appData changed:", appData);
}, [appData]);


const fetchData = async (date, forceRefresh = false) => {
  const dateKey = date.toISOString().split('T')[0];
  console.log("Fetching data for:", dateKey);

  setLoading(prev => ({ ...prev, main: true }));
  try {
    const cachedData = !forceRefresh && getFromCache(dateKey);
    console.log("Cache hit:", !!cachedData, "for date:", dateKey);

    if (cachedData) {
      // When using cached data, we still need configurations
      if (!appData.configs.ventilation || !appData.configs.heating) {

        // Fetch just the configurations if we don't have them
        const configResponse = await fetch('https://j1jjasmb97.execute-api.eu-north-1.amazonaws.com/LoadLogsAndConfigurations-API', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
          },
          body: JSON.stringify({
            account_name: userData.accountName,
            date: dateKey,
            load_ventilation_data: false,
            load_heating_data: false,
            load_configuration_data: true
          })
        });
        const configData = await configResponse.json();
        
        // Merge cached data with fresh configs
        processData({
          ...cachedData,
          configurationsdata: configData.configurationsdata
        }, true);
      } else {
        // Use cached data with existing configs
        processData({
          ...cachedData,
          configurationsdata: {
            body: JSON.stringify({
              aircontrol_configs: appData.configs.ventilation,
              heatingcontrol_configs: appData.configs.heating,
              consumptioncontrol_configs: appData.configs.consumption
            })
          }
        }, false);
      }
      
      loadHistoricalData(currentDate);
      return;
    }

    // If no cache or force refresh, fetch everything
    const response = await fetch('https://j1jjasmb97.execute-api.eu-north-1.amazonaws.com/LoadLogsAndConfigurations-API', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtToken}`
      },
      body: JSON.stringify({
        account_name: userData.accountName,
        date: dateKey,
        load_ventilation_data: true,
        load_heating_data: true,
        load_configuration_data: true
      })
    });

    const data = await response.json();
    console.log("API response for date:", dateKey, data);
    processData(data, true);
    
    if (!forceRefresh) {
      storeInCache(dateKey, data);
    }
  
    loadHistoricalData(currentDate);
    
  } catch (error) {
    console.error('Fetch error:', error);
  } finally {
    setLoading(prev => ({ ...prev, main: false }));
  }
};


const processData = (data, updateConfigs = false) => {
  const newData = { ...appData };
  const newErrors = { ...errors };

  if (data.ventilationdata) {
    
    const { statusCode } = data.ventilationdata;
    console.log ("StatusCode", statusCode)
    if (statusCode === 200 || statusCode === 201) {
      
      const bodyData = typeof data.ventilationdata.body === 'string' 
        ? JSON.parse(data.ventilationdata.body) 
        : data.ventilationdata.body;
      newData.ventilation = bodyData;
      console.log ("newData.ventilation", newData.ventilation)
      newErrors.ventilation = null;
      newErrors.ventilationState = null;
    } else {
      console.log ("TO SET ERROR")
      handleError('ventilation', statusCode, newErrors);
    }
  }

  if (data.heatingcontroldata) {
    const { statusCode } = data.heatingcontroldata;
    if (statusCode === 200 || statusCode === 201) {
      const bodyData = typeof data.heatingcontroldata.body === 'string' 
        ? JSON.parse(data.heatingcontroldata.body) 
        : data.heatingcontroldata.body;
      newData.heating = bodyData;
      newErrors.heating = null;
      newErrors.heatingState = null;
    } else {
      handleError('heating', statusCode, newErrors);
    }
  }

  // Keep existing configs if not updating
  if (updateConfigs && data.configurationsdata) {
    const parsedConfig = (!data.configurationsdata.body || data.configurationsdata.body === null) 
      ? data.configurationsdata
      : JSON.parse(data.configurationsdata.body);
    newData.configs = {
      ventilation: parsedConfig.aircontrol_configs || newData.configs?.ventilation || null,
      heating: parsedConfig.heatingcontrol_configs || newData.configs?.heating || null,
      consumption: parsedConfig.consumptioncontrol_configs || newData.configs?.consumption || null
    };
  } else {
    // Preserve existing configs when not updating
    newData.configs = { ...appData.configs };
  }

  setAppData(newData);
  setErrors(newErrors);
};

const handleConfigSave = async (config, type) => {
  console.log (type, config)
  try {
    const response = await fetch('https://j1jjasmb97.execute-api.eu-north-1.amazonaws.com/SaveConfigs-API', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtToken}`
      },
      body: JSON.stringify({
        account_name: userData.accountName,
        [type]: config
      })
    });

    if (!response.ok) throw new Error('Save failed');
    
    // Update local state immediately for better UX
    setAppData(prevData => ({
      ...prevData,
      configs: {
        ...prevData.configs,
        [type === 'aircontrol_configs' ? 'ventilation' : 
         type === 'heatingcontrol_configs' ? 'heating' : 'consumption']: config
      }
    }));
    
    setSaveStatus('success');

    // Clear the cache for today's date to ensure fresh data on next load
    const today = new Date().toISOString().split('T')[0];
    sessionStorage.removeItem(today);
    
    // Fetch fresh data with configurations
    await fetchData(currentDate, true);
  } catch (error) {
    setSaveStatus('error');
    console.error('Config save error:', error);
  }
};

const handleError = (service, statusCode, errors) => {
  let message = `Error ${statusCode}: An error occurred.`;
  let state = 'genericError';

  switch (statusCode) {
    case 411:
      message = `411 no data: No historical data available for the selected date - try another date.`;
      state = 'noHistoryData';
      break;
    case 410:
      message = `410 no service: service not activated`;
      state = 'noService'; 
      break;
    case 500:
      console.log ("Setting error", service, message)
      message = `500 error generating report`;
      state = 'noService'; 
      break;
    default:
      state = 'genericError';
  }

  errors[service] = message;
  errors[`${service}State`] = state;
  return errors;
};


const storeInCache = (key, data) => {
  const { configurationsdata, ...dataWithoutConfigs } = data;
  
  // Get current date without time
  const today = new Date().toISOString().split('T')[0];
  
  let expiresAt;
  if (key === today) {
    // For today's data, expire at next 15-minute interval
    const now = new Date();
    const minutes = now.getMinutes();
    const nextInterval = Math.ceil(minutes / 15) * 15;
    expiresAt = new Date(now.setMinutes(nextInterval, 0, 0)).getTime();
  } else {
    // For historical data, expire at midnight
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    expiresAt = midnight.getTime();
  }
  
  const cacheData = {
    data: {
      ...dataWithoutConfigs,
      configurationsdata // Include configs in cache
    },
    expiresAt
  };
  
  const compressed = LZString.compressToUTF16(JSON.stringify(cacheData));
  sessionStorage.setItem(key, compressed);
};

const getFromCache = (key) => {
 
  const compressed = sessionStorage.getItem(key);
  if (!compressed) return null;

  try {
    const cacheData = JSON.parse(LZString.decompressFromUTF16(compressed));
    if (Date.now() > cacheData.expiresAt) {
      sessionStorage.removeItem(key);
      return null;
    }

    return cacheData.data;
  } catch (error) {
    sessionStorage.removeItem(key);
    return null;
  }
};

  const loadHistoricalData = async (date) => {
    const dates = [];
    for (let i = 1; i <= 3; i++) {
      const prevDate = new Date(date);
      prevDate.setDate(prevDate.getDate() - i);
      dates.push(prevDate.toISOString().split('T')[0]);
    }

    const uncachedDates = dates.filter(date => !getFromCache(date));
    if (uncachedDates.length === 0) return;

    try {
      await Promise.all(uncachedDates.map(date => 
        fetch('https://j1jjasmb97.execute-api.eu-north-1.amazonaws.com/LoadLogsAndConfigurations-API', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${jwtToken}`
          },
          body: JSON.stringify({
            account_name: userData.accountName,
            date: date,
            load_ventilation_data: true,
            load_heating_data: true,
            load_configuration_data: false
          })
        })
        .then(r => r.json())
        .then(data => storeInCache(date, data))
      ));
    } catch (error) {
      console.error('Error loading historical data:', error);
    }
  };

  // Handlers for changing dates
  const goToPreviousDate = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 1);
      //console.log("Prev date", newDate)
      return newDate;
    });
  };

  const goToNextDate = () => {
    console.log("Next date")
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 1);
      //console.log("Next date", newDate)
      return newDate;
    });
  };

  

  const tabs = [
  {
    id: 'monthly',
    label: 'Status',
    show: true, // Always show this tab
    content: (
      <MonthlyStatusAdapter
        data={appData.monthly}
        currentMonth={currentMonth}
        onPreviousMonth={onPreviousMonth}
        onNextMonth={onNextMonth}
        errors={errors.monthly}
        isLoading={loading.monthly}
        isActualCurrentMonth={isActualCurrentMonth}
        hasMoreHistory={hasMoreHistory}
      />
    )
  },
    {
      id: 'ventilation',
      label: 'Air Controls',
      show: errors.ventilationState !== 'noService' || appData.ventilation !== null,
      content: (
        <VentilationCharts
          currentDate={currentDate}
          key={currentDate.toISOString()} // This is the critical fix
          onPreviousDate={goToPreviousDate}//{() => setCurrentDate(d => new Date(d.setDate(d.getDate() - 1)))}
          onNextDate={goToNextDate}//{() => setCurrentDate(d => new Date(d.setDate(d.getDate() + 1)))}
          ventilationData={appData.ventilation}
          error={errors.ventilation}
          errorState={errors.ventilationState}
        />
      )
    },
    {
      id: 'heating',
      label: 'Energy Controls',
      show: errors.heatingState !== 'noService' && appData.heating !== null,
      content: (
        <HeatingCharts
          currentDate={currentDate}
          onPreviousDate={goToPreviousDate}//{() => setCurrentDate(d => new Date(d.setDate(d.getDate() - 1)))}
          onNextDate={goToNextDate}//{() => setCurrentDate(d => new Date(d.setDate(d.getDate() + 1)))}
          data={appData.heating}
          error={errors.heating}
          errorState={errors.heatingState}
        />
      )
    },
    {
      id: 'ventSettings',
      label: 'Air Parameters',
      show: errors.ventilationState !== 'noService' && appData.configs.ventilation,
      content: (
        <VentilationSettings
          initialVentilationConfigs={appData.configs.ventilation}
          onSave={(config) => handleConfigSave(config, 'aircontrol_configs')}
          saveStatus={saveStatus}
        />
      )
    },
    {
      id: 'heatSettings',
      label: 'Energy Parameters',
      show: errors.heatingState !== 'noService' && appData.configs.heating,
      content: (
        <HeatingSettings
          initialHeatingConfigs={appData.configs.heating}
          onSave={(config) => handleConfigSave(config, 'heatingcontrol_configs')}
          saveStatus={saveStatus}
        />
      )
    },
    {
      id: 'consumptionSettings',
      label: 'Consumption Parameters',
      show: errors.consumptionState !== 'noService' && appData.configs.consumption !== null,
      content: (
        <ConsumptionSettings
          initialConsumptionConfigs={appData.configs.consumption}
          onSave={(config) => handleConfigSave(config, 'consumptioncontrol_configs')}
          saveStatus={saveStatus}
        />
      )
    }
  ];

  const visibleTabs = tabs.filter(tab => tab.show);

  if (loadingUser) return <div>Loading...</div>;

  return (
    <div className="chart-container">
      <p></p>
      <Tabs selectedIndex={tabIndex} onSelect={setTabIndex}>
        <TabList>
          {visibleTabs.map(tab => (
            <Tab key={tab.id}><strong>{tab.label}</strong></Tab>
          ))}
        </TabList>
        {visibleTabs.map(tab => (
          <TabPanel key={tab.id}>
            {/* Only show loading indicator for the current tab */}
            {(tabIndex === 0 && loading.monthly && tab.id === 'monthly') && <div>Loading monthly data...</div>}
            {(tabIndex !== 0 && loading.main && tab.id !== 'monthly') && <div>Loading...</div>}
            {tab.content}
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
}

export default Main;
